<template>
  <div class="number-field" :class="{ accepted: accepted, error: error }">
    <h6 class="label">{{ label }}</h6>
    <div class="input-field">
      <div class="d-flex align-items-center">
        <fa
          icon="angle-left"
          class="control-btn"
          @click="updateViaButtons(parseInt(computedValue || 0) - 1)"
        />
        <input
          class="mx-3"
          type="number"
          :value="computedValue"
          @input="updateValue"
        />
        <fa
          icon="angle-right"
          class="control-btn"
          @click="updateViaButtons(parseInt(computedValue || 0) + 1)"
        />
      </div>
      <fa icon="check" class="checkmark" />
      <fa icon="exclamation" class="exclamation" />
    </div>
    <small class="error-msg">{{ errorMsg }}</small>
  </div>
</template>
<script>
export default {
  name: "number-field",
  props: {
    modelValue: String,
    defaultValue: String,
    state: String,
    label: String,
  },
  watch: {
    modelValue() {
      this.isDefault = false;
    },
  },
  data() {
    return {
      isDefault: false,
    };
  },
  computed: {
    computedValue() {
      if (this.isDefault) {
        return this.defaultValue;
      }
      return this.modelValue;
    },
    accepted() {
      return !this.isDefault && this.state && this.state.startsWith("ACCEPTED");
    },
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
    updateViaButtons(value) {
      this.$emit("update:modelValue", value.toString());
    },
  },
  mounted() {
    if (!this.modelValue && this.defaultValue) {
      this.isDefault = true;
    }
  },
};
</script>
